import "./style.css";
import { jsx as u } from "react/jsx-runtime";
import { c as d } from "../../__shared__/index.js";
const i = "_price_9ogxm_1", a = "_reduced_9ogxm_13", l = "_strikethrough_9ogxm_17", e = {
  price: i,
  default: "_default_9ogxm_9",
  reduced: a,
  strikethrough: l
}, t = {
  default: e.default,
  reduced: e.reduced,
  strikethrough: e.strikethrough
};
function f({
  formattedPrice: r,
  variant: c = "default",
  class: o
}) {
  const s = d(
    e.price,
    t[c] ?? t.default,
    o
  );
  return /* @__PURE__ */ u("span", { className: s, children: r });
}
export {
  f as default
};
//# sourceMappingURL=PriceLabel.js.map
